import React from "react"
import { Scorer } from "../../models/Scorer"
import { IList } from "../../models/Utils"
import { UserCard } from "./UserCard"

export class TopScorerCard extends React.Component<IList<Scorer>>{
    render = () => {
        const { list } = this.props

        return <div className="top-scorer mt-3">
            {
                list.map((s, i) => <UserCard position={i + 1} key={s.username} user={s} />)
            }
        </div>
    }
}